import React from 'react'
import Icon from 'react-icon-base'

const PersonalInformation = props => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g id="PersonalInformation" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="PersonalInformation" transform="translate(-129.000000, -3627.000000)">
        <rect id="Rectangle" fill="#F1F1F1" x="0" y="8" width="1200" height="3822" />
        <g id="Group" transform="translate(32.000000, 410.000000)">
          <g id="Group-7" transform="translate(0.000000, 3171.000000)">
            <rect
              id="Rectangle-Copy"
              stroke="#DDDDDD"
              fill="#FFFFFF"
              x="0.5"
              y="0.5"
              width="1135"
              height="148"
              rx="4"
            />
            <g id="Group-21" transform="translate(28.000000, 46.000000)">
              <g id="Group-3" transform="translate(69.000000, 0.000000)">
                <rect id="Rectangle" stroke="#3498DB" strokeWidth="2" x="1" y="1" width="29" height="31" rx="2" />
                <g
                  id="Page-1-Copy-2"
                  transform="translate(5.000000, 7.000000)"
                  stroke="#3498DB"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2.06896552">
                  <path
                    d="M13.2384616,5.30228046 C13.2384616,2.67512204 11.1079988,0.54465927 8.48084038,0.54465927 C5.85368196,0.54465927 3.72321919,2.67512204 3.72321919,5.30228046 C3.72321919,7.92943888 5.85368196,10.0599016 8.48084038,10.0599016 C11.1079988,10.0599016 13.2384616,7.92943888 13.2384616,5.30228046 Z"
                    id="Stroke-1"
                  />
                  <path
                    d="M16.6282667,18.2073279 C16.6282667,13.7080456 12.9801227,10.0599016 8.48084038,10.0599016 C3.98155802,10.0599016 0.333414093,13.7080456 0.333414093,18.2073279"
                    id="Stroke-3"
                  />
                </g>
                <g id="Group-2" transform="translate(24.500000, 6.000000)">
                  <g id="Group">
                    <circle id="Oval" fill="#3498DB" cx="2" cy="1.5" r="1.5" />
                    <line
                      x1="2.6"
                      y1="1.5"
                      x2="7.4"
                      y2="1.5"
                      id="Line-2"
                      stroke="#3498DB"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </g>
                  <g id="Group-Copy" transform="translate(0.000000, 6.000000)">
                    <circle id="Oval" fill="#3498DB" cx="2" cy="1.5" r="1.5" />
                    <line
                      x1="2.6"
                      y1="1.5"
                      x2="7.4"
                      y2="1.5"
                      id="Line-2"
                      stroke="#3498DB"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </g>
                  <g id="Group-Copy-2" transform="translate(0.000000, 12.000000)">
                    <circle id="Oval" fill="#3498DB" cx="2" cy="1.5" r="1.5" />
                    <line
                      x1="2.6"
                      y1="1.5"
                      x2="7.4"
                      y2="1.5"
                      id="Line-2"
                      stroke="#3498DB"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </g>
                  <g id="Group-Copy-3" transform="translate(0.000000, 18.000000)">
                    <circle id="Oval" fill="#3498DB" cx="2" cy="1.5" r="1.5" />
                    <line
                      x1="2.6"
                      y1="1.5"
                      x2="7.4"
                      y2="1.5"
                      id="Line-2"
                      stroke="#3498DB"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </Icon>
)

PersonalInformation.defaultProps = {
  size: 30
}

export default PersonalInformation
